import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeDeltaCapital';
const args = {};

export class ModeDeltaCapital extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
